import React, { useEffect, useState } from 'react';
import { Grid, Typography, Divider, Box, Tooltip, makeStyles } from "@material-ui/core";
import Modal from "../../../shared/components/Modal"
import Loading from "../../../shared/components/Loading";
import ScrollBarGradiente from "../../../shared/components/ScrollBarGradiente";
import CardAmostrasNoLote from "./CardAmostrasNoLote";
import MensagemListagemVazia from "../../../shared/components/MensagemListagemVazia";
import { formatarData, formatarDataEHora, formatarHora, formatarTemperatura } from "../../../shared/utils/Formatacao";
import { Edit3 } from 'react-feather';
import { Link } from "react-router-dom";
import { formatarCodigoLote } from "../../../shared/utils/Formatacao";
import { NOME_ARQUIVO_DADOS_LOTE, TIPO_LOTE_KPA_CODIGO } from '../../../shared/utils/Constantes'
import Botao from '../../../shared/components/Botao';
import LotesManager from '../LotesManager';
import { iniciarDownload } from '../../../shared/utils/ArquivoUtil';
import TextFieldPesquisa from '../../../shared/components/TextFieldPesquisa';
import DateRangePickerAntd from '../../../shared/components/DateRangePickerAntd';
import moment from 'moment';

const ModalVisualizacaoDadosLote = ({
    lote,
    amostras,
    eventos,
    modalAberto,
    handleFecharModal,
    carregandoAmostras }) => {

    const classes = useStyles();
    const [loteKPA, setLoteKPA] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [amostrasFiltradas, setAmostrasFiltradas] = useState(amostras);
    const [erroDataFuturaColeta, setErroDataFuturaColeta] = useState(false);
    const [erroDataFuturaRecebimento, setErroDataFuturaRecebimento] = useState(false);
    const [filtros, setFiltros] = useState({
        termoBusca: '',
        periodoColeta: {
            dataInicio: null,
            dataFim: null,
        },
        periodoRecebimento: {
            dataInicio: null,
            dataFim: null
        },
    });

    const dadoCabecalho = (nome, valor) => (
        <Grid item xs={12} className="mb-1">
            <Typography variant="body2">
                <span className="bold">{nome}:</span> {valor || "-"}
            </Typography>
        </Grid>
    );

    const handleExportarExcel = async () => {
        setLoadingExcel(true);

        await LotesManager.exportarDadosLote(lote.id)
            .then((resposta) => {
                const nomeArquivo = NOME_ARQUIVO_DADOS_LOTE + "-" + lote.codigo.toString().padStart(12, '0');
                iniciarDownload(resposta, nomeArquivo);
            })
            .finally(() => setLoadingExcel(false));
    };

    const handleChangeTermoBusca = (event) => {
        const novoTermo = event.target.value;
        setFiltros({
            ...filtros,
            termoBusca: novoTermo
        });

        setErroDataFuturaColeta(false);
        setErroDataFuturaRecebimento(false);
    };

    const handlePeriodoColetaChange = (dataInicio, dataFim) => {
        setFiltros({
            ...filtros,
            periodoColeta: { dataInicio, dataFim }
        });

        setErroDataFuturaRecebimento(false);
    };

    const handlePeriodoRecebimentoChange = (dataInicio, dataFim) => {
        setFiltros({
            ...filtros,
            periodoRecebimento: { dataInicio, dataFim }
        });

        setErroDataFuturaColeta(false);
    };

    const mensagemListaVazia = (amostrasFiltradas.length === 0 && amostras.length > 0
        ?
        <MensagemListagemVazia
            className={`${classes.mensagemListaVazia} mt-2 mb-0`}
        >
            Não foram encontradas amostras para a sua pesquisa. <br />
            Faça uma nova pesquisa para ver os resultados.
        </MensagemListagemVazia>
        :
        <MensagemListagemVazia
            className="mt-2 mb-0"
            iconeCustom={(props) => <Edit3 {...props} />}
        >
            O lote ainda não contém amostras. <br />
            {loteKPA ? null : <>
                Clique <Link className={"link"} to={{ pathname: 'dados-lote', search: `?idLote=${lote.id}` }}> aqui </Link>
                para editar o lote e cadastrar amostras.
            </>
            }
        </MensagemListagemVazia>);

    const cards = (amostras.length > 0 && amostrasFiltradas.length > 0
        ?
        <ScrollBarGradiente
            estilo={estilosScrollBar(lote.quantidadeAmostras)}
            exibirGradiente={false}
            habilitarScrollHorizontal={false}
        >
            <Grid container spacing={1} className={"pr-3"}>
                {amostrasFiltradas
                    .map(amostra => (
                        <Grid item xs={3} key={amostra.id}>
                            <CardAmostrasNoLote
                                amostra={amostra}
                            />
                        </Grid>
                    )
                    )
                }
            </Grid>
        </ScrollBarGradiente>
        : mensagemListaVazia);
    useEffect(() => {
        const { termoBusca, periodoColeta, periodoRecebimento } = filtros;

        const amostrasFiltradas = amostras.filter(amostra => {
            const termoLowerCase = termoBusca.toLowerCase();
            const dataCadastroAmostra = moment(amostra.dataCadastro);
            const dataRecebimentoAmostra = moment(amostra.dataRecebimento);
            const termo = (
                amostra.nomePaciente.toLowerCase().includes(termoLowerCase) ||
                amostra.status.toLowerCase().startsWith(termoLowerCase) ||
                amostra.codigo.toLowerCase().includes(termoLowerCase) ||
                amostra.exames.toLowerCase().includes(termoLowerCase)
            );

            const dentroPeriodoColeta = (
                !periodoColeta.dataInicio ||
                !periodoColeta.dataFim ||
                (dataCadastroAmostra >= periodoColeta.dataInicio && dataCadastroAmostra <= periodoColeta.dataFim)
            );

            const dentroPeriodoRecebimento = (
                !periodoRecebimento.dataInicio ||
                !periodoRecebimento.dataFim ||
                (dataRecebimentoAmostra >= periodoRecebimento.dataInicio && dataRecebimentoAmostra <= periodoRecebimento.dataFim)
            );

            return termo && dentroPeriodoColeta && dentroPeriodoRecebimento;
        });

        setAmostrasFiltradas(amostrasFiltradas);
    }, [filtros]);

    useEffect(() => {
        setAmostrasFiltradas(amostras)
    }, [amostras]);

    useEffect(() => {
        if (lote?.tipoLote?.codigo === TIPO_LOTE_KPA_CODIGO)
            setLoteKPA(true)
    }, [lote]);

    useEffect(() => {
        const limparFiltros = () => {
            setErroDataFuturaColeta(false);

            setErroDataFuturaRecebimento(false);

            setFiltros({
                termoBusca: '',
                periodoColeta: {
                    dataInicio: null,
                    dataFim: null,
                },
                periodoRecebimento: {
                    dataInicio: null,
                    dataFim: null
                },
            });
        };

        limparFiltros();
    }, [modalAberto]);

    return (

        <Modal className={classes.modal}
            modalAberto={modalAberto}
            desabilitarCliqueForaModal={false}
            iconeFechar={true}
            maxWidth={"lg"}
            fecharModal={handleFecharModal}
        >
            <Grid container>
                <Grid container xs={12} className={classes.tituloModal}>
                    <Grid item xs={10}>
                        <Typography variant="h3">
                            <span className="bold">Dados do lote </span>
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Botao
                            id="ExportarDadosLote"
                            type="primary"
                            className={classes.botao}
                            titulo="Exportar Excel"
                            onClick={() => {
                                handleExportarExcel()
                            }}
                            disabled={amostras.length === 0}
                            carregando={loadingExcel}
                        />
                    </Grid>
                </Grid>
                <Grid container xs={12} className="mb-4">
                    <Grid item xs={4}>
                        <Typography variant="h4">
                            <span className="bold">Lote (Nº da etiqueta): </span> {formatarCodigoLote(lote.codigo)}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant="h4">
                            <span className="bold">Rastreabilidade de eventos</span>
                        </Typography>
                    </Grid>
                </Grid>

                <Grid Item xs={4} className={classes.espacamentoContainer}>
                    {dadoCabecalho("Tipo do lote", lote.tipoLote?.descricao)}
                    {dadoCabecalho("Data de cadastro", lote.dataCadastro === null ? '- -' : formatarData(lote.dataCadastro) + " às " +
                        formatarHora(lote.dataCadastro))}
                    {dadoCabecalho("Data de recolhimento", lote.dataRecolhimento === null ? '- -' : formatarData(lote.dataRecolhimento) + " às " +
                        formatarHora(lote.dataRecolhimento))}
                    {dadoCabecalho("Conservação do lote", lote.tipoConservacao?.descricao)}
                    {dadoCabecalho("Temperatura de cadastro", formatarTemperatura(lote.temperatura))}
                    {dadoCabecalho("Temperatura de chegada", formatarTemperatura(lote.temperaturaChegada))}
                    {dadoCabecalho("Status", lote.status?.descricao)}
                    {dadoCabecalho("Região produtiva LC", lote.regiaoProdutiva ?? "-")}
                </Grid>

                <Grid Item xs={8} className={classes.espacamentoContainer}>
                    <Grid item container xs={12} spacing={2} className="mb-1">
                        <Grid item xs={2}>
                            <Typography variant="body2">
                                <span className="bold">Evento</span>
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="body2">
                                <span className="bold">Descrição</span>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body2">
                                <span className="bold">Data</span>
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="body2">
                                <span className="bold">Responsável</span>
                            </Typography>
                        </Grid>
                    </Grid>
                    {
                        carregandoAmostras === false && eventos.map(e =>
                            <Typography variant="body2">
                                <Grid container item xs={12} className="mb-1">
                                    <Grid item xs={2} className="mb-1">
                                        <Typography variant="body2" className={"text-overflow-ellipsis"}>
                                            <span>{e.evento}</span>
                                        </Typography>
                                    </Grid>
                                    <Grid container item xs={4} justifyContent="space-between">
                                        <Tooltip title={e.descricao} placement={'middle'}>
                                            <Typography noWrap className={classes.tamanhoCaixaTexto}>{e.descricao}</Typography>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <span>{formatarDataEHora(e.data)}</span>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <span>{e.responsavel}</span>
                                    </Grid>
                                </Grid>
                            </Typography>
                        )
                    }
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>

                <Grid item align="left" xs={12} className={classes.espacamentoTituloAmostraLote}>
                    <Typography variant="h4">
                        {lote.quantidadeAmostras === 1
                            ? "1 Amostra no Lote"
                            : lote.quantidadeAmostras + " Amostras no Lote"}
                    </Typography>
                </Grid>

                {amostras.length > 0 &&
                    <Grid container spacing={2}>
                        <Grid item xs={6} className={classes.gridTermo}>
                            <TextFieldPesquisa
                                label={'Pesquisar por paciente, status, amostra ou exames'}
                                value={filtros.termoBusca}
                                onChange={handleChangeTermoBusca}
                                className={classes.filtroTermo}
                                alterarIconeHover
                            />
                        </Grid>
                        <Grid item xs={3} className={classes.gridPeriodo}>
                            <DateRangePickerAntd
                                periodoHandler={handlePeriodoColetaChange}
                                bloqueiaDataFutura
                                label='Período de coleta'
                                error={erroDataFuturaColeta}
                                setError={setErroDataFuturaColeta}
                            />
                        </Grid>
                        <Grid item xs={3} className={classes.gridPeriodo}>
                            <DateRangePickerAntd
                                periodoHandler={handlePeriodoRecebimentoChange}
                                bloqueiaDataFutura
                                label='Período de recebimento'
                                error={erroDataFuturaRecebimento}
                                setError={setErroDataFuturaRecebimento}
                            />
                        </Grid>
                    </Grid>
                }
            </Grid>

            <Box className="largura-maxima mb-2 mt-7">
                {carregandoAmostras ?
                    <Loading loading size={30} className={"mt-0 mb-0"} />
                    : cards
                }
            </Box>
        </Modal>
    );
}

const alturaLinhaAmostras = 150;
const amostrarPorLinha = 4;
const alturaMinimaScroll = alturaLinhaAmostras;

const estilosScrollBar = (quantidadeAmostras) => {
    const numeroLinhas = Math.ceil(quantidadeAmostras / amostrarPorLinha);
    const altura = numeroLinhas * alturaLinhaAmostras;

    return {
        width: "100%",
        height: Math.max(alturaMinimaScroll, altura) + "px",
        maxHeight: "calc(100vh - 260px)",
        // 260 = 32 margin + 16 padding + 201 conteudo e cabecalho + 11 extra
    }
}

const useStyles = makeStyles((theme) => ({
    cardArquivo: {
        marginTop: -theme.spacing(1),
        marginBottom: -theme.spacing(1),
    },
    modal: {
        height: "100%",
        "& .MuiDialog-paperFullWidth": {
            height: 'calc(100% - 24px)'
        },
    },
    botao: {
        bottom: "0px",
        right: "80px",
        width: "216px",
        height: "47px",
    },
    espacamentoTituloAmostraLote: {
        margin: "28px 0"
    },
    espacamentoContainer: {
        margin: "16px 0 28px 0"
    },
    tamanhoCaixaTexto: {
        width: '225px',
        fontSize: '14px'
    },
    tituloModal: {
        marginBottom: '28px'
    },
    filtroTermo: {
        '& .MuiInputLabel-root': {
            '&.Mui-focused': {
                color: theme.palette.secondary.main + '!important',
            },
        },
    },
}
))



export default ModalVisualizacaoDadosLote;
